module.exports = __webpack_public_path__ + "aa76465e8165da1659c990ce4aab5b0c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/logo.png
// module id = ./assets/images/header/logo.png
// module chunks = 0